export default __webpack_public_path__ + "static/media/thsarabunnew-webfont.6cdb6eb5.eot";